<template>
  <v-autocomplete
    v-model="selected"
    :search-input.sync="search"
    :items="items"
    :loading="loading"
    :disabled="disabled"
    :label="searchLabel"
    return-object
    item-text="itemText"
    placeholder="Start typing to Search"
  >
    <template v-slot:item="data">
      <template>
        <v-list-item-content>
          <v-list-item-title v-if="title(data.item)" v-html="title(data.item)"></v-list-item-title>
          <v-list-item-subtitle>slug: {{ data.item.slug }}</v-list-item-subtitle>
          <v-list-item-subtitle v-if="subtitle(data.item)" v-html="subtitle(data.item)"></v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'LeanSearchRecord',
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    config: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selected: null,
      items: [],
      loading: false,
      search: null,
      bounceSearch: null
    };
  },
  computed: {
    ...mapState({
      datatypes: 'models',
      language: 'selectedLanguage'
    }),
    listConfig() {
      return this.datatypes[this.config.source].list || null;
    },
    searchLabel: {
      get() {
        return `Search for ${this.config.source}`;
      }
    },
  },
  methods: {
    async querySelections(val) {
      this.loading = true;
      this.items = [
        ...((
          await this.$store.state.sdk.getDocuments({
            datatype: this.config.source,
            language: this.language,
            query: val
          })
        ).records || []),
        ...((
          await this.$store.state.sdk.getDocuments({
            datatype: this.config.source,
            language: this.language,
            filenames: [`data/${this.config.source}/${val}/${this.language}/index.json`]
          })
        ).records || [])
      ].map((item) => {
        let itemText = item.slug;
        if (this.listConfig?.title) {
          const title = item.data[this.listConfig.title];
          itemText += `||${title}`;
        }
        if (this.listConfig?.subtitle) {
          const subtitle = item.data[this.listConfig.subtitle];
          itemText += `||${subtitle}`;
        }
        return {
          ...item,
          itemText
        };
      });
      this.loading = false;
    },
    title(item){
      if (this.listConfig?.title) {
          return item.data[this.listConfig.title];
      }
      return ''
    },
    subtitle(item){
      if (this.listConfig?.subtitle) {
          return item.data[this.listConfig.subtitle];
      }
      return ''
    }
  },
  watch: {
    search(val) {
      if (val !== this.selected) {
        clearTimeout(this.bounceSearch);
        this.bounceSearch = setTimeout(() => {
          this.querySelections(val);
        }, 800);
      }
    },
    async selected(val) {
      console.log('selected', val);
      if(val){
        this.$emit('change', val);
        await this.$nextTick(() => {
          this.selected = null;
        })
      }
    }
  }
};
</script>
